/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandBulma = createReactComponent("outline", "brand-bulma", "IconBrandBulma", [["path", { "d": "M5 16l1 -9l5 -5l6.5 6l-3.5 4l5 5l-8 5z", "key": "svg-0" }]]);

export { IconBrandBulma as default };
//# sourceMappingURL=IconBrandBulma.mjs.map
